import { QuoteAdditionalFieldsSchema } from '@monetize/types/app';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';
import { useGetContractById } from '../../api/cpqService';
import { logger } from '../../services/logger';
import { MSkeleton } from '../Monetize';
import { RenewalModal } from './RenewalModal';

export const RenewalRouteWrapper = ({
  handleClose,
}: {
  handleClose: (accountId: string) => void;
}) => {
  const location = useLocation();
  const { contractId = '' } = useParams();

  const additionalFields = useMemo(() => {
    if (location.state && (location.state as any).additionalFields) {
      const parseResults = QuoteAdditionalFieldsSchema.safeParse(
        (location.state as any).additionalFields,
      );
      if (!parseResults.success) {
        logger.warn('Invalid additional fields:', parseResults.error);
      } else {
        return parseResults.data;
      }
    }
  }, [location.state]);

  const { data: contract, isLoading: isContractLoading } = useGetContractById(
    contractId,
    {
      enabled: !!contractId,
      meta: { showErrorToast: true },
    },
  );

  if (isContractLoading) {
    return <MSkeleton height={10} w="full" mt={4} />;
  }

  return (
    contract && (
      <RenewalModal
        contract={contract}
        onClose={() => handleClose(contract.accountId)}
        additionalFields={additionalFields}
      />
    )
  );
};
